import { type BaselinePeriodRestrictionLegacy } from '@verantos-dev/types-cohorts';
import { Cohort_definitionContext } from '@verantos-dev/util-cohort-builder-typescript-runtime';

export const generateBaseLinePeriod = (
  cohortDefinitionTree: Cohort_definitionContext
): BaselinePeriodRestrictionLegacy | undefined => {
  if (!cohortDefinitionTree.study_period_criteria) return undefined;

  const baselinePeriodRestriction = cohortDefinitionTree
    ?.baseline_period_criteria()
    ?.baseline_period();

  return {
    isEnabled: true,
    daysBeforeIndexDate: parseInt(baselinePeriodRestriction?.INT()?.getText() || '0'),
  };
};
